import { useSelector } from 'react-redux'
import { GCDSDropdown, GCDSButtonDropdown } from '@gocanvas/gcds/components';
import { elementsActions } from 'apps/studio/store/reducers/entities/elements'
const { updateElementStyles } = elementsActions
import { uniqueFontTypesSelector } from 'apps/studio/store/selectors/types'
import { useDispatch } from 'react-redux'

export const SettingsElementStyleSelect = ({
  entryGuid,
  label,
  choices,
  property,
  data,
  update,
  selectProps = {},
  iconOnly = false,
  valueOnly = false,
  components = {},
  ...rest
}) => {
  const dispatch = useDispatch()
  const updateAction = update
    ? update
    : props => updateElementStyles({ entry_guid: entryGuid, ...props })

  const SelectComponent = iconOnly ? GCDSButtonDropdown : GCDSDropdown

  return (
    <SelectComponent
      id={`${property}-${entryGuid}`}
      label={label}
      options={choices}
      value={choices.find(({ value }) => value === data[property])}
      onChange={({ value }) => dispatch(updateAction({ [property]: value }))}
      className={`settings-element-style-select settings-element-style-select--${property}`}
      additionalProps={selectProps}
      {...rest}
      inputType="secondary"
    />
  )
}

export const SettingsFontFamilySelect = ({
  entryGuid,
  property = 'fontFamily',
  data,
  selectProps = {},
  ...rest
}) => {
  const fontTypes = useSelector(uniqueFontTypesSelector)

  const choices = fontTypes.map(({ displayName, fileName }) => ({
    label: displayName,
    value: fileName,
    style: {
      fontFamily: fileName,
      // other style props for individual items
    }
  }))

  return (
    <SettingsElementStyleSelect
      entryGuid={entryGuid}
      choices={choices}
      property={property}
      data={data}
      size="large"
      selectProps={selectProps}
      isSearchable={false}
      allowFontStyles={true}
      {...rest}
    />
  )
}
